export default function () {
	function getSelectedDistances() {
		let distances = [];
		let selectedItems = $('.select2 ul.select2-selection__rendered li');
		selectedItems.each(function() {
			let selectedDistance = $(this).find('.locality-ld-choice');
			let localityId = selectedDistance.data('id');
			distances[localityId] = selectedDistance.val();
		});
		return distances;
	}

	let activeDistances = [];
//setTimeout(function () {
	$.fn.select2.amd.require([/*'select2/diacritics',*/ 'select2/selection/search'], function (/*DIACRITICS,*/ Search) {
		Search.prototype.searchRemoveChoice = function (decorated, item) {
			this.trigger('unselect', {
				data: item
			});

			this.$search.val('');
			this.handleSearch();
		};
		$('.with-select2 select').each(function () {
			let searchAjax = null;
			const isLocationsInput = $(this).data('type') === 'locations';
			const isPersonalAgenciesInput = $(this).data('type') === 'personal-agencies';
			const isEmployersInput = $(this).data('type') === 'employers';
			const distance = $(this).data('distance');
			const type = $(this).data('locations-type');
			const dataCy = $(this).data('cy');


			// toto je mezivrstva, ktera zaruci naplneni seznamu select2 drive nez se provede ajax request
			const transportFunc = function (params, success, failure) {
				const term = select2.data('typedTerm');

				if (term !== '') { // fill select menu items when user inserted some text before starting ajax request
					const customItem = {
						id: `${term}`,
						text: `${term}`,
					};

					success({results: [customItem]});
				}

				// Now perform the real AJAX request and pass the results later
				const request = $.ajax(params);
				request.then(function (remoteData) {
					success(remoteData);
				}).fail(failure);

				return request;
			}

			if (isLocationsInput) {
				searchAjax = {
					url: "/data-locations.json",
					delay: 0,
					data: function (params) {
						if (type === undefined) {
							return {
								q: params.term
							}
						}  else {
							return {
								q: params.term,
								type: type
							}
						}
					},
					cache: true
				};
			} else if (isPersonalAgenciesInput || isEmployersInput) {
				searchAjax = {
					url: isPersonalAgenciesInput ? "/data-pa.json" : "/data-em.json",
					delay: 0,
					data: function (params) {
						select2.data('typedTerm', params.term); // save term to list first item before loading ajax
						return {
							q: params.term
						};
					},
					transport: transportFunc, //tady povolujeme hledani fraze
					cache: true
				};
			} else {
				searchAjax = {
					url: "/data-professions.json",
					delay: 0,
					data: function (params) {
						select2.data('typedTerm', params.term); // save term to list first item before loading ajax
						var type = $(this).data('ot');
						if (type === undefined) {
							type = window.location.pathname.substring(1, 2);
						}

						return {
							q: params.term,
							t: type,
							//,page: params.page
						};
					},
					transport: transportFunc, //tady povolujeme hledani fraze
					cache: true
				};
			}

			const theme = $(this).data('theme');

			let tokenSeparator = [',', ';'];

			if (isLocationsInput) {
				tokenSeparator = [];
			}

			const select2 = $(this).select2({
				language: 'cs',
				minimumResultsForSearch: 10,
				tokenSeparators: tokenSeparator,
				ajax: searchAjax,
				theme: (theme || 'common'),
				tags: false,
				multiple: true,
				templateResult: function (value) {
					if (isLocationsInput || !isNaN(value.id)) {
						if (value.is_parent) {
							var $result = $("<strong></strong>");
						} else {
							var $result = $("<span></span>");
						}
						$result.text(value.text);
						return $result;
					}

					const el = document.createElement('div');
					el.className = 'fulltext';

					el.innerText = 'hledat výraz ';
					if (value.id !== undefined) {
						if (value.id !== value.text) {
							if (value.id.lastIndexOf("p", 0) === 0) {
								el.innerText = 'profese: ';
							} else if (value.id.lastIndexOf("c", 0) === 0) {
								el.innerText = 'firma: ';
							} else if (value.id.lastIndexOf("a", 0) === 0) {
								el.innerText = 'agentura: ';
							}
						}
					}

					const text = document.createElement('strong');
					text.innerText = value.text;

					el.appendChild(text);

					return el;
				},
				templateSelection: function (value) {
                    if (isLocationsInput) { //|| !isNaN(value.id)
                        var type = getType(value);
                        var defaultRadius = getDefaultRadius(value);

                        if (['city', 'city_part'].includes(type) && (distance === undefined || distance === 1)) { // || type == 'prague_number' || type === 'prague'
                            var locationSelectedDistance = defaultRadius ?? 50;
							if (typeof currentLocationsDistances !== 'undefined') {
								if (currentLocationsDistances.hasOwnProperty(value.id)) {
									locationSelectedDistance = parseInt(currentLocationsDistances[value.id]);
								}
							}
							if (activeDistances.hasOwnProperty(value.id)) {
								locationSelectedDistance = parseInt(activeDistances[value.id]);
							}
							var localityRadius = '<span class="localityChoiceCont"><select name="ld[' + value.id + ']" class="search-custom-html-element locality-ld-choice" id="locality-ld-' + value.id + '" data-id="' + value.id + '"><option value="0" ' + (locationSelectedDistance === 0 ? 'selected' : '') + '>+ 0 km</option><option value="10" ' + (locationSelectedDistance === 10 ? 'selected' : '') + '>+ 10 km</option><option value="20" ' + (locationSelectedDistance === 20 ? 'selected' : '') + '>+ 20 km</option><option value="30" ' + (locationSelectedDistance === 30 ? 'selected' : '') + '>+ 30 km</option><option value="40" ' + (locationSelectedDistance === 40 ? 'selected' : '') + '>+ 40 km</option><option value="50" ' + (locationSelectedDistance === 50 ? 'selected' : '') + '>+ 50 km</option></select></span>';
                            return $('<span class="locality-name">' + value.text + '</span>' + localityRadius);
                        }

                        return $('<span class="locality-name">' + value.text + '</span>');
                    }

					return value.text;
				},
			}).attr({
				'role': 'combobox',             // Označení jako rozbalovací seznam
				'aria-haspopup': 'listbox',     // Upozornění, že se otevře seznam
				'aria-expanded': 'false',       // Indikace, zda je seznam otevřený
			});

			if (!$(this).select2('data').length) {
				//při prázdném boxu se input s placeholdrem nemá jak roztáhnout na celou šířku a placeholder nemusí být vidět celý. Dáme tedy rodiči dynamicky 100%
				$(this).next('span.select2.select2-container.select2-container--search').find('.selection .select2-search.select2-search--inline').addClass('set-width');
			} else {
				//pokud je něco vybráno, input již není třeba držet na celou šířku
				$(this).next('span.select2.select2-container.select2-container--search').find('.selection .select2-search.select2-search--inline').removeClass('set-width');
			}

            function getType(item) {
                if (item.type !== undefined) {
                    return item.type;
                } else if (item.element.dataset.type !== undefined) {
                    return item.element.dataset.type;
                }
                return false;
            }

			function getDefaultRadius(item) {
				let radius = false;
				if (item.dr !== undefined) {
					radius = parseInt(item.dr);
				} else if (item.element.dataset.dr !== undefined) {
					radius = parseInt(item.element.dataset.dr);
				}
				return radius;
			}

			select2.on('select2:closing', function (e) {
				function add(value) {
					var newOption = new Option(value, value, true, true);
					select2.append(newOption).trigger('change');
				}

				document.querySelectorAll('.select2-search__field').forEach(function (el) {
					if (!searchAjax && !select2.val().length && el.value) {
						add(el.value);
					}
				});
			});

			select2.on('select2:open', function () {
				$(this).attr('aria-expanded', 'true');
				$form.off('keyup', '.select2-selection', select2EnterEvent);
			});

			select2.on('select2:close', function () {
				$(this).attr('aria-expanded', 'false');
			});

			select2.on('select2:change', function () {
				$form.off('keyup', '.select2-selection', select2EnterEvent);
			});

			select2.focus(function () { // click on label opens select
				select2.select2('open');
			});


			var $form = select2.parents('form');

			var select2EnterEvent = function (e) {
				if (e.keyCode === 13) {
					$form.submit();
				}
			};

			select2.on('select2:select', function (e) {
				$form.off('keyup', '.select2-selection', select2EnterEvent);
				if (e.currentTarget.getAttribute('data-type') !== undefined) {
					if (e.currentTarget.getAttribute('data-type') === 'subjects') {
						if (typeof e.params.originalEvent !== 'undefined' && e.params.originalEvent.keyCode === 9) {
							document.getElementById('frm-lbl-locations').focus();
						}
						// document.getElementsByName('locations[]').focus()
					} else if (e.currentTarget.getAttribute('data-type') === 'locations') {
						if (typeof e.params.originalEvent !== 'undefined' && e.params.originalEvent.keyCode === 9) {
							document.getElementById('frm-btn-submit').focus()
						}
						// document.querySelectorAll('button[type=submit]').focus()
					}
				}
				//pokud je něco vybráno, input již není třeba držet, kvůli placeholderu, na celou šířku
				$(this).next('span.select2.select2-container.select2-container--search').find('.selection .select2-search.select2-search--inline').removeClass('set-width');
				// distances
				// locationSelectedDistance
			});

			select2.on('select2:opening', function (e) {
				$form.on('keyup', '.select2-selection', select2EnterEvent);
				activeDistances = getSelectedDistances();

				let reset = select2.data('reset');
				if (reset === 1) {
					$(this).val(null);
				}
			});

			select2.on('select2:unselect', function(e) {
			 	const index = [...e.currentTarget.options].findIndex(o => o.value === e.params.data.text); e.currentTarget.remove(index);
				if ($(this).select2('data').length === 0) {
					//pokud se box vyprázdní, input s placeholdrem se nemá jak roztáhnout na celou šířku a placeholder nemusí být vidět celý. Dáme tedy rodiči dynamicky 100%
					$(this).next('span.select2.select2-container.select2-container--search').find('.selection .select2-search.select2-search--inline').addClass('set-width');
				}
			});

			if (dataCy !== undefined) {
				select2.parent().find('input').attr('data-cy', dataCy+'-input');
			}
		})
	});
//}, 1000);
}
